<script>
import { mapActions, mapGetters } from 'vuex'
import { authComputed } from '@/state/helpers'
import helper from './helper'
import simplebar from 'simplebar-vue'

export default {
  name: 'cart-dropdown',
  components: {
    simplebar
  },
  mixins: [helper],
  computed: {
    ...mapGetters('cart', ['cartCount', 'cartItems']),
    ...authComputed
  },
  async mounted () {
    await this.cartSubscription()
  },
  methods: {
    ...mapActions('cart', ['cartSubscription']),
    onViewCartHandler () {
      if (this.$route.name !== 'cart.list')
        this.$router.push({ name: 'cart.list' })
    }
  }
}
</script>
<template>
  <b-dropdown
    right
    menu-class="dropdown-menu-lg p-0"
    toggle-class="header-cartItem noti-icon"
    variant="black"
    :disabled="cartCount === 0"
  >
    <template v-slot:button-content>
      <i class="bx bx-cart" :class="{ 'bx-tada': cartCount > 0 }"></i>
      <span class="badge badge-danger badge-pill" v-if="cartCount > 0">{{
        cartCount
      }}</span>
    </template>
    <simplebar style="max-height: 230px">
      <a
        href="javascript: void(0);"
        class="text-reset notification-item"
        v-for="cartItem in cartItems"
        :key="cartItem.id"
      >
        <div class="d-flex p-3">
          <div class="mr-3">
            <i class="fab fa-wpforms fa-flip-horizontal"></i>
          </div>
          <div class="d-flex flex-column">
            <span class="d-block text-truncate m-0">{{
              cartItem.item.short_description
            }}</span>
            <small
              class="d-block justify-content-center text-truncate mt-1 text-muted"
              v-if="cartItem.item.webshop_custom_form"
              >ref. {{ cartItem.reference }}
            </small>
          </div>

          <small class="ml-auto d-flex justify-content-end" style="width: 40px">
            <i class="mdi mdi-close mr-1"></i> {{ cartItem.quantity }}
          </small>
        </div>
      </a>
    </simplebar>
    <div class="border-top">
      <b-dropdown-item
        class="d-block"
        v-on:click="onViewCartHandler"
        :disabled="cartCount === 0"
      >
        <div class="py-1">
          <i class="bx bx-cart font-size-16 align-middle mr-1"></i>
          {{ $t('view cart') }} - {{ cartCount }}
          {{ $tc('cartItem', cartCount) }}
        </div>
      </b-dropdown-item>
    </div>
    <!-- cartItem-->
  </b-dropdown>
</template>
